import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BusinessUnitService } from '@app/api/user-service/api/businessUnit.service';
import { BusinessUnitSearchRequest } from '@app/api/user-service/model/businessUnitSearchRequest';
import {
  PaginatedDropdownLoadParams,
  PaginatedOptionsPage,
} from '@shared/utils/paginated-dropdown.util';

@Injectable({ providedIn: 'root' })
export class BusinessUnitOptionsService {
  private readonly businessUnitService = inject(BusinessUnitService);

  getDepartmentOptionsPage(
    params: PaginatedDropdownLoadParams,
  ): Observable<PaginatedOptionsPage<number>> {
    const searchText = params.searchText?.trim();
    const request: BusinessUnitSearchRequest = {
      page: params.page - 1,
      size: params.size,
      externalType: 'DEPARTMENT',
      name: searchText || undefined,
    };

    return this.businessUnitService
      .search(request, 'body', false, {
        httpHeaderAccept: 'application/json' as any,
      })
      .pipe(
        map((response) => {
          const units = response.pageContent ?? [];
          return {
            options: units
              .filter((bu) => bu.id != null)
              .map((bu) => ({
                label: bu.name || bu.code || `BU ${bu.id}`,
                value: bu.id!,
              })),
            pageContentLength: units.length,
            totalElements: response.totalElements,
          };
        }),
        catchError(() => of({ options: [], pageContentLength: 0 })),
      );
  }
}
